export const urgencyLevelMap = {
    "0": "正常",
    "1": "一般异常",
    "2": "紧急异常"
}